import { useState } from 'react'

export default function useGeolocationPosition() {
    const [geolocationPosition, setGeolocationPosition] = useState(null)
    function refreshGeolocationPosition() {
        navigator?.geolocation?.getCurrentPosition?.(setGeolocationPosition)
    }
    return { geolocationPosition, refreshGeolocationPosition }
}
